import { motion } from "framer-motion";

const T = {
  fr: { title: "Nous revenons très vite", sub: "Cocoon Mind se repose un instant pour mieux rallumer ta curiosité." },
  en: { title: "We'll be back very soon", sub: "Cocoon Mind is resting for a moment to better rekindle your curiosity." },
  es: { title: "Volvemos muy pronto", sub: "Cocoon Mind descansa un instante para reavivar mejor tu curiosidad." },
  nl: { title: "We zijn snel terug", sub: "Cocoon Mind rust even om je nieuwsgierigheid beter aan te wakkeren." },
};

export function MaintenancePage({ message }) {
  // Français par défaut ; on n'utilise la langue du navigateur que si l'utilisateur l'a explicitement choisie.
  let stored = "fr";
  try { stored = (localStorage.getItem("coccon_lang") || "fr").slice(0, 2); } catch (e) { /* noop */ }
  const c = T[stored] || T.fr;

  return (
    <div className="min-h-screen starfield flex items-center justify-center px-6 text-center" data-testid="maintenance-page">
      <div
        aria-hidden
        className="pointer-events-none absolute inset-x-0 top-0 h-[60vh] blur-[120px] opacity-60"
        style={{ background: "radial-gradient(ellipse at 50% 20%, hsl(32 96% 56% / 0.20), transparent 70%)" }}
      />
      <motion.div
        initial={{ opacity: 0, y: 18 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="relative max-w-lg"
      >
        <motion.img
          src="/cocoon-logo-glow.png"
          alt="Cocoon Mind"
          className="w-24 h-24 mx-auto mb-8 object-contain"
          animate={{ opacity: [0.7, 1, 0.7], scale: [1, 1.04, 1] }}
          transition={{ duration: 3.4, repeat: Infinity, ease: "easeInOut" }}
          data-testid="maintenance-logo"
        />
        <h1 className="font-display text-gradient-orange text-4xl sm:text-5xl leading-tight" data-testid="maintenance-title">
          {c.title}
        </h1>
        <p className="mt-5 text-foreground/60 leading-relaxed" data-testid="maintenance-sub">
          {message?.trim() ? message : c.sub}
        </p>
        <p className="mt-10 text-primary/70 tracking-[0.3em] uppercase text-xs">Cocoon Mind</p>
      </motion.div>
    </div>
  );
}
